// DS: C41
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BiData } from '@wix/da-bi/pkg/events';
import TagList from '@wix/da-ds/pkg/TagList';
import Tag from '@wix/da-ds/pkg/TagList/Tag';
import { useChildrenFolding } from '@wix/da-hooks/pkg/useChildrenFolding';
import s from './FoldableTagList.scss';
var MAX_LINES = 2;
var TAG_SPACING = parseInt(s['tag-spacing'], 10);
var TOGGLE_BUTTON_WIDTH = parseInt(s['more-button-width'], 10);
/** A DS TagList that includes a final, tag-like toggle button that
 *  folds or expands the list from 2 lines to as many as needed. */
export var FoldableTagList = function (_a) {
    var tags = _a.tags, className = _a.className, _b = _a.isFoldable, isFoldable = _b === void 0 ? true : _b;
    var t = useTranslation().t;
    var _c = useState(isFoldable), isFolded = _c[0], setIsFolded = _c[1];
    var _d = useChildrenFolding(tags, {
        maxLines: MAX_LINES,
        itemSpacing: TAG_SPACING,
        endPadding: TOGGLE_BUTTON_WIDTH,
        getItemKey: function (tag) { return tag.name; },
        excludeChild: function (element) { return element.classList.contains(s['more-or-less']); },
    }), sizedItems = _d.sizedItems, hasHidden = _d.hasHidden, containerRef = _d.containerRef;
    // TODO: remove if/when devpage_tags_update is merged
    // TODO: may also want to consolidate useChildrenFolding since isOversized isn't needed
    var sizedTags = useMemo(function () {
        return sizedItems.map(function (_a) {
            var item = _a.item, isOverflow = _a.isOverflow;
            return ({
                tagname: item.name,
                href: item.url,
                className: isFoldable && isFolded && isOverflow ? s['overflowed'] : undefined,
                biData: BiData({
                    evid: 391,
                    tag_text: item.name,
                    link_url: item.url,
                }),
            });
        });
    }, [sizedItems, isFoldable, isFolded]);
    return (React.createElement(TagList, { className: className, tags: sizedTags, size: "medium", isTruncated: true, multiline: true, ref: containerRef }, isFoldable && hasHidden && (React.createElement(Tag
    /* no collision bc hyphens aren't accepted in tag creation */
    , { 
        /* no collision bc hyphens aren't accepted in tag creation */
        key: "more-or-less", className: s['more-or-less'], size: "medium", onClick: function () { return setIsFolded(!isFolded); }, biData: BiData({
            evid: 2,
            click_info: isFolded ? 'more' : 'less',
        }) }, t(isFolded ? 'common.more' : 'common.less')))));
};
FoldableTagList.displayName = 'FoldableTagList';
export default FoldableTagList;
//# sourceMappingURL=FoldableTagList.js.map